import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateImage from './components/Image';
import LearnMoreLink from './components/LearnMoreLink';

import { userHasFeature } from '../../helpers/Features';
import UnlockButton from './components/UnlockButton';

const EmptyGuestUploads = ({ handleNewItem }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Get files from anyone' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Use guest upload pages to receive files from anyone - without adding them to your Stockpress workspace.' })}
        </div>
        <div>
          {userHasFeature('upload-pages') ? (
            <Button color="primary" className="mt-4" onClick={handleNewItem}>
              <span>
                {intl.formatMessage({ defaultMessage: 'Create guest upload page' })}
              </span>
            </Button>
          ) : (
            <UnlockButton feature="upload-pages" />
          )}
          <LearnMoreLink url="https://help.stockpress.co/en/articles/8902917-external-upload-pages" />
        </div>
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-guest-upload-page.png" />
    </div>
  );
};

EmptyGuestUploads.propTypes = {
  handleNewItem: PropTypes.func,
};

EmptyGuestUploads.defaultProps = {
  handleNewItem: () => {},
};

export default EmptyGuestUploads;
